import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Importar Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';

// Pages
import Login from './pages/Login';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Sales from './pages/Sales';
import Reports from './pages/Reports';
import Users from './pages/Users';
import Segments from './pages/Segments';
import AdvanceGeneral from './pages/AdvanceGeneral';
import Clients from './pages/Clients';

// Lazy loading para las páginas protegidas
const Teams = React.lazy(() => import('./pages/Teams'));
const Sellers = React.lazy(() => import('./pages/Sellers'));
const Catalog = React.lazy(() => import('./pages/Catalog'));

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Ruta pública */}
          <Route path="/login" element={<Login />} />

          {/* Rutas protegidas */}
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="users" element={<Users />} />
            <Route path="segments" element={<Segments />} />
            <Route path="clients" element={<Clients />} />
            <Route
              path="sales"
              element={
                <React.Suspense fallback={<div>Cargando...</div>}>
                  <Sales />
                </React.Suspense>
              }
            />
            <Route
              path="teams"
              element={
                <React.Suspense fallback={<div>Cargando...</div>}>
                  <Teams />
                </React.Suspense>
              }
            />
            <Route
              path="sellers"
              element={
                <React.Suspense fallback={<div>Cargando...</div>}>
                  <Sellers />
                </React.Suspense>
              }
            />
            <Route
              path="catalog"
              element={
                <React.Suspense fallback={<div>Cargando...</div>}>
                  <Catalog />
                </React.Suspense>
              }
            />
            <Route
              path="reports"
              element={
                <React.Suspense fallback={<div>Cargando...</div>}>
                  <Reports />
                </React.Suspense>
              }
            />
            <Route path="advance-general" element={<AdvanceGeneral />} />
          </Route>

          {/* Ruta por defecto */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
